export const prices = [
  "https://giphy.com/embed/WU8nnAdxZWeM8",
  "https://giphy.com/embed/myuLckXB7OjfGw1gSb",
  "https://giphy.com/embed/RyqiL8NJMUzvi",
  "https://giphy.com/embed/401riYDwVhHluIByQH",
  "https://giphy.com/embed/cYejmY7tuJ4HTmBYHP",
];

export const emojis = [
  { emoji: "🐒", id: "monkey" },
  { emoji: "🐳", id: "whale" },
  { emoji: "🐧", id: "penguin" },
  { emoji: "🦊", id: "fox" },
  { emoji: "🐼", id: "panda" },
  { emoji: "🐥", id: "chicken" },
  { emoji: "💥", id: "explosion" },
  { emoji: "💩", id: "Donald Trump" },
  { emoji: "🔪", id: "knife" },
  { emoji: "🚽", id: "Afd" },
  { emoji: "💣", id: "bomb" },
  { emoji: "☠️", id: "skull" },
  { emoji: "🔫", id: "gun" },
  { emoji: "🔥", id: "fire" },
  { emoji: "❄️", id: "ice" },
  { emoji: "⚡", id: "lightning" },
];

export const animalIds = ["monkey", "whale", "penguin", "fox", "panda", "chicken"];
// The higher this number the harder the game gets
export const DIFFICULTY_DESKTOP = 0.13;
export const DIFFICULTY_MOBILE = 0.09;
